module.exports = __webpack_public_path__ + "static/leafy-c68192325ac499e25841fe576e9ad817.jpg";